export const CATALOG_REFRESH_SUPERSEDED = Symbol('catalog-refresh-superseded');

// Retry only an explicitly superseded request, once. Network errors propagate;
// repeated realtime invalidations must not turn initialization into a fetch loop.
export const loadCatalogForInitialization = async (refresh, isActive) => {
  for (let attempt = 0; attempt < 2 && isActive(); attempt += 1) {
    const result = await refresh();
    if (!isActive()) return null;
    if (result !== CATALOG_REFRESH_SUPERSEDED) {
      return Array.isArray(result) ? result : null;
    }
  }
  return null;
};

// Resolve the document before opening the catalog generation used to hydrate it.
// This prevents a catalog that was current before a slow document request from
// overwriting a newer realtime refresh after that document finally arrives.
export const loadDocumentAndCatalogForInitialization = async (
  loadDocument,
  refreshCatalog,
  isActive
) => {
  const document = await loadDocument();
  if (!isActive()) return null;
  const catalog = await loadCatalogForInitialization(refreshCatalog, isActive);
  if (!isActive() || !Array.isArray(catalog)) return null;
  return { document, catalog };
};
